(function () {
    'use strict';

    angular
        .module('app.memberAdmin')
        .component('sc3AdjustScores', {
            templateUrl: 'app/member-admin/adjust-scores/adjust-scores.component.html',
            controller: AdjustScoresComponent,
            bindings: {
                individualId: '<'
            }
        });

    AdjustScoresComponent.$inject = ['$state', '$scope', '$timeout', 'Member', 'alert', 'memberAdminResources'];
    function AdjustScoresComponent($state, $scope, $timeout, Member, alert, resources) {
        var ctrl = this;

        // Properties        
        ctrl.adjustment = null;

        // Methods        
        ctrl.submit = submit;

        /////////////////////////////////////////////
        
        function submit() {            
            if (ctrl.form.$valid)
                Member.saveScoreAdjustment({ id: ctrl.individualId }, ctrl.adjustment, success, error, true);

            function success() {
                $scope.$emit('$userChanged');
                $timeout(alert.success.bind(alert, resources.adjustScoresSucceeded));
            }
            function error() {
                alert.error(resources.adjustScoresFailed);
            }
        }

    }
})();